import { render } from "./AreaTematica.vue?vue&type=template&id=908fa19e"
import script from "./AreaTematica.vue?vue&type=script&lang=ts"
export * from "./AreaTematica.vue?vue&type=script&lang=ts"
script.render = render

export default script